import { NgModule } from '@angular/core';
import { ExerciceService } from './exercice.service';
import { UIElementModule } from 'src/app/core';

const declareAndExport = [
]
const declareAndEntryComponent = [
]

@NgModule({
	imports: [UIElementModule],
	declarations: [declareAndExport, declareAndEntryComponent],
	exports: [declareAndExport],
	entryComponents: [declareAndEntryComponent],
	providers: [ExerciceService]
})
export class ExerciceModule { }
